// Shown (in place of the gallery) when a tenant resolves to something other than a public,
// published Keep: a themed "gallery is private" page for unshared Keeps, a "not found" page for
// unknown links, and a spinner while resolving. Themed via the Keep's palette + motif.
import { FloralSpray, Ornament } from "../components/Florals";
import { Engraved, Script } from "../components/ui";
import { useBranding, useKeepStatus, useKeepTheme } from "../lib/keep";

export function StatusScreen() {
  const status = useKeepStatus();
  const branding = useBranding();
  const { scriptClass } = useKeepTheme();

  if (status === "loading") {
    return (
      <div className="status-screen">
        <div className="spinner" />
      </div>
    );
  }

  const notfound = status === "notfound";
  const name = branding.displayName;

  return (
    <div className="status-screen">
      <FloralSpray variant="topBorder" density="lush" className="status-deco" />
      <div className="status-inner">
        <span className="status-ic" aria-hidden="true">
          {notfound ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="26" height="26">
              <circle cx="11" cy="11" r="7.5" /><path d="m20 20-4.3-4.3" /><path d="M11 8v4M11 14.4v.1" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="26" height="26">
              <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" /><circle cx="12" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
            </svg>
          )}
        </span>
        <Engraved size={11} style={{ letterSpacing: "0.28em", color: "var(--c-ink-soft)" }}>
          {notfound ? "Not found" : "Private gallery"}
        </Engraved>
        {!notfound && name && (
          <Script size={46} className={"hero-names status-name " + scriptClass}>{name}</Script>
        )}
        <p className="status-msg">
          {notfound
            ? "This link doesn't lead to a gallery. Double-check it with whoever shared it — it may have moved or been removed."
            : "The host hasn't shared this gallery publicly. If you're hoping to see or add photos from this gathering, reach out to the host and they can send you the link."}
        </p>
        <Ornament color="var(--c-line)" width={120} />
      </div>
    </div>
  );
}
